"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _fetchTranslations = require("./fetchTranslations");
Object.keys(_fetchTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fetchTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fetchTranslations[key];
    }
  });
});
var _updateDefaultNamespacesWithFetchedTranslations = require("./updateDefaultNamespacesWithFetchedTranslations");
Object.keys(_updateDefaultNamespacesWithFetchedTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateDefaultNamespacesWithFetchedTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateDefaultNamespacesWithFetchedTranslations[key];
    }
  });
});
var _makeValueAsKey = require("./makeValueAsKey");
Object.keys(_makeValueAsKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _makeValueAsKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _makeValueAsKey[key];
    }
  });
});
//# sourceMappingURL=index.js.map